import React from 'react'
import OperationsList from "./Operation/OperationsList"

const Dashboard = () => {
  return (
    <main>
      <OperationsList />
    </main>
  )
}

export default Dashboard